import { ajaxActions } from 'common/ajax/store.js';
import { basePath } from 'common/config.js';

const RECEIVED_ALL_TRANSACTIONS = 'RECEIVED_ALL_TRANSACTIONS';
const RECEIVED_ALL_GROUPED_TRANSACTIONS = 'RECEIVED_ALL_GROUPED_TRANSACTIONS';
const REST_TRANSACTION_PAGE = 'REST_TRANSACTION_PAGE';
const initialState = {
  accountInfor: {},
  transactions: {},
  groupedTransactions: {},
};

export const actionCreators = {
  getAllTransactions: (adfitNo) => (dispatch) => {
    let url = `${basePath}/api/accounts/${adfitNo}/transactions`;
    dispatch(
      ajaxActions.sendAjaxRequest(
        url,
        'GET',
        (result) => {
          dispatch({ type: RECEIVED_ALL_TRANSACTIONS, result: result });
        },
        null,
        true
      )
    );
  },
  getAllGroupedTransactions: (adfitNo) => (dispatch) => {
    let url = `${basePath}/api/accounts/${adfitNo}/groupedTransactions`;
    dispatch(
      ajaxActions.sendAjaxRequest(
        url,
        'GET',
        (result) => {
          dispatch({ type: RECEIVED_ALL_GROUPED_TRANSACTIONS, result: result });
        },
        null,
        true
      )
    );
  },
  resetTransPage: () => (dispatch) => {
    dispatch({ type: REST_TRANSACTION_PAGE, result: {} });
  },
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === RECEIVED_ALL_TRANSACTIONS) {
    return {
      ...state,
      transactions: action.result,
    };
  } else if (action.type === RECEIVED_ALL_GROUPED_TRANSACTIONS) {
    return {
      ...state,
      groupedTransactions: action.result,
    };
  } else if (action.type === REST_TRANSACTION_PAGE) {
    return {
      ...state,
      transactions: {},
      accountInfor: {},
      groupedTransactions: {},
    };
  }

  return state;
};
